import { Select, Option, FormControl, FormHelperText } from "@deere/fuel-react";
import React from "react";

const Dropdown = (props) => {
  const handleOnChange = (event) => {
    props.onDropdownChange(event.target.value);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "21rem" }}>
      {props.label ? <label>{props.label}</label> : null}
      <FormControl>
        <Select
          disabled={props.disabled}
          error={props.error}
          helperText={props.msg}
          aria-describedby="my-helper-text"
          onChange={handleOnChange}
          value={props.value}
        >
          {props?.options?.map((item) => (
            <Option key={item} value={item}>
              {item}
            </Option>
          ))}
        </Select>
        {props.helperText ? (
          <FormHelperText error={props.error} id="my-helper-text">
            {props.helperText}
          </FormHelperText>
        ) : null}
      </FormControl>
    </div>
  );
};

export default Dropdown;
